if (!customElements.get('testimonials-component')) {
  class Testimonials extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.testimonials__items',
        pagination: '.swiper-pagination',
        nextElDesktop: '.swiper-controls--desktop .swiper-btn-next',
        prevElDesktop: '.swiper-controls--desktop .swiper-btn-prev',
        nextElMobile: '.swiper-controls--mobile .swiper-btn-next',
        prevElMobile: '.swiper-controls--mobile .swiper-btn-prev',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items);
      this.tabletItems = parseInt(this.dataset.tabletItems);

      this.sliderInstance = false;

      if (!this.enableSlider) return;

      this.init();
      document.addEventListener('matchMobile', () => {
        this.init();
      });
      document.addEventListener('unmatchMobile', () => {
        this.init();
      });
    }

    init() {
      if (typeof this.sliderInstance === 'object') {
        this.destroySlider();
      }

      this.initSlider();
    }

    initSlider() {
      const isMobile = FoxTheme.config.mqlMobile;
      const columnGap = window
        .getComputedStyle(this.sliderWrapper)
        .getPropertyValue(isMobile ? '--gap-x' : '--column-gap');
      const gapValue = parseFloat(columnGap) || 0;
      const spaceBetween = columnGap.includes('px') ? gapValue : gapValue * 10;
      const nextEl = this.section.querySelector(isMobile ? this.selectors.nextElMobile : this.selectors.nextElDesktop);
      const prevEl = this.section.querySelector(isMobile ? this.selectors.prevElMobile : this.selectors.prevElDesktop);
      const mobileSpaceBetween = Math.min(spaceBetween, 12);

      const sliderOptions = {
        slidesPerView: 1,
        spaceBetween: isMobile ? mobileSpaceBetween : spaceBetween,
        navigation: {
          nextEl,
          prevEl,
        },
        pagination: false,
        breakpoints: {
          768: {
            slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
          },
          1280: {
            slidesPerView: parseInt(this.items),
          },
        },
        loop: true,
        threshold: 2,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();
        
        const focusableElements = FoxTheme.a11y.getFocusableElements(this);
        
        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });
      }
      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          let { target } = e;
          const index = Number(target.dataset.index);
          
          this.sliderInstance.slider.slideToLoop(index);
        });
      }
      setTimeout(() => {
        this.sliderInstance.slider.slideToLoop(1, 0, false);
      }, 1);
      


    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }
  customElements.define('testimonials-component', Testimonials);
}
